import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavItemProps {
  href: string;
  icon: React.ReactNode;
  label: string;
  isCollapsed: boolean;
  onClick?: () => void;
}

function NavItem({
  href,
  icon,
  label,
  isCollapsed,
  onClick
}: NavItemProps): React.ReactElement {
  const location = useLocation();
  const isActive = location.pathname.includes(href);

  return (
    <Link
      to={href}
      onClick={onClick}
      className={`
        flex items-center px-4 py-2 mx-2 my-1 rounded-[10px] transition-all
        hover:bg-[#012438] hover:text-white
        ${isActive ? 'bg-[#012438] text-white' : 'text-white'}
        ${isCollapsed ? 'justify-center' : ''}
      `}
    >
      <div className={`w-5 h-5 ${isCollapsed ? '' : 'mr-3'}`}>{icon}</div>
      {!isCollapsed && <span className='text-base'>{label}</span>}
    </Link>
  );
}

export default NavItem;
